class Voucher {
  constructor(data) {
    this.id = data.id
    this.expiresOn = data.expiresOn
    this.from = data.from
    this.fromEmail = data.fromEmail
    this.product = data.product
    this.redeemUrl = data.redeemUrl
    this.status = data.status
    this.statusId = data.statusId
    this.periodAccess = data.periodAccess
    this.code = data.code
    this.message = data.message
  }
}
export default Voucher;
